import type { IntegrationSettingsDto, SettingsDto, SettingsTestResultDto } from './dtos/settings/models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CustomSettingsService {
  apiName = 'Default';
  

  getTestConnection = (isVirtualAgent?: boolean, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SettingsTestResultDto>({
      method: 'GET',
      url: '/api/agentic-cx/custom-settings/test-connection',
      params: { isVirtualAgent },
    },
    { apiName: this.apiName,...config });
  

  set = (configurationsSettingsDtos: SettingsDto[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/agentic-cx/custom-settings/set',
      body: configurationsSettingsDtos,
    },
    { apiName: this.apiName,...config });
  

  setHostSettings = (configurationsSettingsDtos: SettingsDto[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/agentic-cx/custom-settings/set-host-settings',
      body: configurationsSettingsDtos,
    },
    { apiName: this.apiName,...config });
  

  setIntegration = (request: IntegrationSettingsDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/agentic-cx/custom-settings/set-integration',
      body: request,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
